import React from "react";
import {  MDBContainer } from "mdbreact";


const Managed = () => {
    return (
        <MDBContainer id="managed" className="text-center my-5">
            <h2 className="h1-responsive font-weight-bold my-5">
                Managed Services
            </h2>
            <p className="lead black-text w-responsive mx-auto mb-5">
                We can manage your Digital Services from Google Analytics to client email 
                campaigns and E-shots, looking after the development, list management 
                and distribution. We'll also help you learn about your digital 
                communications and how your customers interact.
            </p>
        </MDBContainer>
    );
}

export default Managed;